import { render, staticRenderFns } from "./OfferLetter1.vue?vue&type=template&id=7045efc6&scoped=true&"
var script = {}
import style0 from "./OfferLetter1.vue?vue&type=style&index=0&id=7045efc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045efc6",
  null
  
)

export default component.exports